import React from "react";

const ErrorMessageRender = (msg: string) => (
  <small className="form-text text-warning">{msg}</small>
)

export default ErrorMessageRender;